import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12719744"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "mt-n3 mb-1 text-dark" }, "Estamos quase lá")
], -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", null, "Galeria de Imagens", -1));
const _hoisted_4 = { class: "row" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-info" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "far fa-lightbulb" }),
        /*#__PURE__*/ _createTextVNode(" Você pode escolher até 3 imagens ou vídeos do youtube para ilustrar a galeria de sua campanha. ")
    ])
], -1));
const _hoisted_6 = { class: "col-sm-12" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    id: "btn-gerenciar-galeria",
    class: "btn btn-primary btn-block",
    type: "button",
    "data-toggle": "modal",
    "data-target": "#modal-galeria"
}, " Gerenciar Galeria ", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", null, "Sugestões de valores para doações", -1));
const _hoisted_9 = { class: "mb-2 text-muted" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_GaleriaCarrossel = _resolveComponent("GaleriaCarrossel");
    const _component_ValoresSugeridos = _resolveComponent("ValoresSugeridos");
    const _component_ModalGaleria = _resolveComponent("ModalGaleria");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("fieldset", null, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_GaleriaCarrossel, {
                            vitrines: _ctx.campanha.vitrines
                        }, null, 8, ["vitrines"]),
                        _hoisted_7
                    ])
                ])
            ]),
            _createElementVNode("fieldset", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("i", null, [
                        _createTextVNode(" Preencha os campos abaixo com os valores que gostaria de sugerir aos seus doadores. O valor mínimo da doação é "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.campanha.causa?.valor_minimo), 1),
                        _createTextVNode(". ")
                    ])
                ]),
                _createVNode(_component_ValoresSugeridos, {
                    "onUpdate:valoresSugeridos": _cache[0] || (_cache[0] = (valores) => _ctx.campanha.valores_sugeridos = valores)
                })
            ])
        ]),
        _createVNode(_component_ModalGaleria)
    ], 64));
}
